import { BpModalCanDismiss } from "@models/interfaces/bp-modal-can-dismiss";
import { AuthService } from "bp-authorization-lib";
import { Component } from "@angular/core";
import { CustomModal } from "@modules/core/components/base-modals";

@Component({
	templateUrl: "./aml5-modal.component.html",
	styleUrls: ["./aml5-modal.component.scss"],
	standalone: false
})
export class Aml5ModalComponent extends CustomModal implements BpModalCanDismiss {
	public constructor(private authService: AuthService) {
		super();
	}

	public onContinueClicked(): void {
		window.location.href = `${this.authService.getApiUrl()}/aml/questions`;
	}

	public modalCanDismiss(): boolean {
		return false;
	}
}
